<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
</script>
<template>
  <div class="bg-gray-50 min-h-screen">
    <index-navbar />
    <section class="header py-8 pt-24">
      <div class="container mx-auto px-4 max-w-5xl">
        <!-- 引言部分 -->
        <div class="bg-white rounded-xl shadow-md p-8 mb-8">
          <p class="text-2xl text-gray-700 leading-relaxed">
            Welcome to MigraineNexus! MigraineNexus is a comprehensive platform designed to accelerate migraine research by integrating large-scale molecular data analysis with deep literature-derived knowledge. The platform comprises two primary modules: Gene Expression Interactive Analysis module and Knowledge Graph module.
          </p>
        </div>

        <!-- A-to-I和C-to-U模块 -->
        <div class="bg-white rounded-xl shadow-md p-8 mb-8">
          <h2 class="font-bold text-4xl text-blue-800 mb-6 pb-2 border-b-2 border-blue-100">Gene Expression Interactive Analysis</h2>

          <h3 class="font-bold text-3xl text-gray-800 mt-6 mb-4">Information</h3>
          <p class="text-2xl text-gray-700 leading-relaxed mb-4">
            In the Gene Expression Interactive Analysis module for each species, the Information submodule allows users to search and access detailed information for individual genes. This includes:
          </p>
          <p class="text-2xl text-gray-700 leading-relaxed mb-4">
            Gene Detailed Information (Ensembl ID, Description, Alias, PubChem CID of Targeted Compounds,Herb,Summary)<br>Results of differential gene expression analyses across various projects and comparison conditions(Project,BaseMean,log2FoldChange,Pvalue,Padj,Group,Significance)
          </p>
          <div class="my-6 p-4 bg-gray-100 rounded-lg border border-gray-200 shadow-sm">
            <img src="@/assets/pic/t1.png" class="w-full rounded-md border border-gray-300 shadow-md">
          </div>
          <div class="my-6 p-4 bg-gray-100 rounded-lg border border-gray-200 shadow-sm">
            <img src="@/assets/pic/t2.png" class="w-full rounded-md border border-gray-300 shadow-md">
          </div>
        </div>

        <!-- Correlation部分 -->
        <div class="bg-white rounded-xl shadow-md p-8 mb-8">
          <h3 class="font-bold text-3xl text-gray-800 mt-6 mb-4">Knowledge Graph</h3>
          <p class="text-2xl text-gray-700 leading-relaxed mb-4">
            In the Knowledge Graph submodule, users can search the knowledge graph by selecting an entity type and entering the entity name, obtaining the entity’s relevant network as well as associated literature data.
          </p>
          <div class="my-6 p-4 bg-gray-100 rounded-lg border border-gray-200 shadow-sm">
            <img src="@/assets/pic/t3.png" class="w-full rounded-md border border-gray-300 shadow-md">
          </div>
          <div class="my-6 p-4 bg-gray-100 rounded-lg border border-gray-200 shadow-sm">
            <img src="@/assets/pic/t3_1.png" class="w-full rounded-md border border-gray-300 shadow-md">
          </div>
          <div class="my-6 p-4 bg-gray-100 rounded-lg border border-gray-200 shadow-sm">
            <img src="@/assets/pic/t3_2.png" class="w-full rounded-md border border-gray-300 shadow-md">
          </div>
          <p class="text-2xl text-gray-700 leading-relaxed mb-4">
            Select the entity name under the entity type and click 'LOAD NETWORK'.
          </p>
        </div>

        <!-- DOWNLOAD部分 -->
        <div class="bg-white rounded-xl shadow-md p-8 mb-8">
          <h2 class="font-bold text-4xl text-blue-800 mb-6 pb-2 border-b-2 border-blue-100">DOWNLOAD Section</h2>
          <p class="text-2xl text-gray-700 leading-relaxed mb-4">
            In the DOWNLOAD section, users can download the following files:
          </p>
<!--          <ol class="list-decimal list-inside text-2xl text-gray-700 space-y-2 ml-4">-->
<!--            <li>Comprehensive information on A-to-I editing events in the A-to-I data file, also C-to-U editing events in the C-to-U data file.</li>-->
<!--            <li>The relationship between editing levels of A-to-I sites across various organs and age in the Correlation file.</li>-->
<!--            <li>Corresponding GTEx sample details in the Sample information file.</li>-->
<!--            <li>The distribution of RNA editing sites across different cell types in peripheral blood in the Singlecell Atlas file.</li>-->
<!--          </ol>-->
          <div class="my-6 p-4 bg-gray-100 rounded-lg border border-gray-200 shadow-sm">
            <img src="@/assets/pic/t19.png" class="w-full rounded-md border border-gray-300 shadow-md">
          </div>
        </div>

        <!-- 结尾部分 -->
        <div class="bg-white rounded-xl shadow-md p-8 mb-8">
          <p class="text-2xl text-gray-700 leading-relaxed">
            We hope this guide helps you make the most of the MigraineNexus. For any further assistance, please refer to the detailed documentation or contact our support team. Happy analyzing!
          </p>
        </div>
      </div>
    </section>

    <footer-component />
  </div>
</template>

<style scoped>
.header {
  background: linear-gradient(to bottom, #f8fafc, #e2e8f0);
  min-height: 100vh;
}

.container {
  max-width: 1200px;
}

ol li {
  margin-bottom: 0.5rem;
}
</style>